module.exports = __webpack_public_path__ + "img/minus-solid.8737477f.svg";